  <div class="card shadow-sm border table-border-color rounded-lg p-3 text-xs">
  <div class="table-responsive overflow-auto">
    <table :id="table_id" class="table table-hover mb-0 w-auto full-width-table">
      <thead class="custom-header">
        <tr>
          <th
            v-for="header in headers"
            :key="header"
            class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3 text-nowrap"
          >
            {{ header }}
          </th>
          <th v-if="$slots.actions" class="text-uppercase text-xxs font-weight-bolder opacity-7 text-nowrap">
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!safe_data.length">
          <td :colspan="column_span" class="text-xxs text-muted">
            {{ empty_message }}
          </td>
        </tr>
        <tr v-for="(row, index) in safe_data" v-else :key="index">
          <td v-for="(value, key) in row" :key="key" class="text-xxs text-start text-nowrap">
            {{ value || value === 0 ? value : "-" }}
          </td>
          <td v-if="$slots.actions" class="text-start text-nowrap">
            <div class="d-flex gap-2 flex-nowrap">
              <slot name="actions" :row="row"></slot>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div
    v-if="show_pagination && total_pages > 1"
    class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mt-4"
  >
    <span class="text-xxs text-muted">{{ summary_text }}</span>
    <div class="d-flex justify-content-end align-items-center gap-2">
      <button
        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
        :disabled="!prev_page || loading"
        type="button"
        @click="change_page(prev_page)"
      >
        Previous
      </button>
      <span class="text-xxs text-muted">Page {{ page_number }} of {{ total_pages }}</span>
      <button
        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
        :disabled="!next_page || loading"
        type="button"
        @click="change_page(next_page)"
      >
        Next
      </button>
    </div>
  </div>
</div>
